// Import core lib dependencies.
import { createSelector } from 'reselect';

// Config.
import Config			  from './config/config.js';

/**
 * <pre>
 * Overlay module Selectors(s).
 *
 * Summary of responsibilities:
 *
 *  - defines reusable selectors to retrieve state properties
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Overlay
 * @namespace
 *
 * @type {Object}
 */
const Selectors = {};

/**
 * Selector to access totalInstances property of Redux state for this module.
 *
 * @memberof module:Overlay.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const totalInstancesSelector = (state) => state[Config.stateKey].totalInstances;
Selectors.getTotalInstances = createSelector(
	[totalInstancesSelector],
	(stateVal) => {
		return stateVal;
	}
);

/**
 * Selector to access instances property of Redux state for this module.
 *
 * @memberof module:Overlay.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const instancesSelector = (state) => state[Config.stateKey].instances;
Selectors.getInstances = createSelector(
	[instancesSelector],
	(stateVal) => {
		return stateVal;
	}
);

export default Selectors;